exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".t123 {\n  color: pink;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/runner/_work/monorepo/monorepo/admin-portal-old/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/runner/_work/monorepo/monorepo/admin-portal-old/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/home/runner/_work/monorepo/monorepo/admin-portal-old/node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!/home/runner/_work/monorepo/monorepo/admin-portal-old/src/styles/test.less
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../less-loader/dist/cjs.js?{"sourceMap":false}!../../../../../src/styles/test.less
// module chunks = styles